export default "__VITE_ASSET__StMPgbAc__"